class DocumentPollResults {

    constructor() {

        this._baseScreenTemplate = null;

        this._loadTemplates();

    }

    _loadTemplates() {

        this._baseScreenTemplate = Handlebars.compile($("#baseScreen").html());

    }

    // IZE-9629 (FR-023): la Encuesta se envía a través del mismo endpoint `.../register` que Juego
    // y Test (ver `sendCompleteDocumentGame`). Para la encuesta, `register` completa siempre
    // (`PollCompletionPolicy::canComplete()` es incondicional) pero NO devuelve `completed` en su
    // respuesta, así que la completitud se marca aquí localmente, sin llamadas de red adicionales.
    updatePollDocument(pollResults) {

        // `register` devuelve `document_id` como string; el store de React compara ids con `===`.
        const documentId = parseInt(pollResults.document_id);
        const document = documentationScreenController.getDocument(documentId);
        const isNewlyCompleted = !document?.completed;

        if (document) {
            document.own_poll.games = pollResults.games;
            document.own_poll.num_entries = parseInt(document.own_poll.num_entries) + 1;

            const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

            if (isModuleApp) {
                // update module-app content
                window.reactZustandBridge.updateContentByContentId(documentId, document);

                // update legacy document
                documentationScreenController.documentsAsResources[documentId] = document;
            }
        }

        documentObj.own_poll.games = pollResults.games;
        documentObj.own_poll.num_entries = parseInt(documentObj.own_poll.num_entries) + 1;

        // Si es encuesta dejar de registrar tiempo al terminar la encuesta
        documentationScreenController.documentationProgress.stopRead(documentId);
        documentationScreenController.documentationProgress.markCompletedLocally(
            documentId,
            0,
            null,
            isNewlyCompleted
        );

    }

    goToMainApp() {

        const $mainContainer = $("#mainContainer");
        const document = documentationScreenController.getDocument(documentObj.id);
        const parentFolder = documentationScreenController.getParentFolder(documentObj.id, documentationScreenController.documentation);

        const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

        $mainContainer.html(this._baseScreenTemplate(world));
        baseController.draw(world.theme);

        // Force this flow when is module app (igual que DocumentGameResults.goToMainApp): si no, el
        // visor sigue mostrando el detalle pintado antes de responder (botón "Jugar").
        if (isModuleApp || baseController.currentActiveTab.id === new Tabs().LINKS_TAB) {
            // Force close poll screen (if is module app), igual que DocumentTestResults.goToMainApp
            if (isModuleApp) {
                const closePollButton = window.document.querySelector('#legacyStack #documentation-header-close-btn');

                if (closePollButton) {
                    closePollButton.click();
                }
            }

            documentationScreenController.openDocumentation(documentationScreenController.documentation, null, null, false);
            documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);
        } else {
            baseController.selectedTabAction(baseController.currentActiveTab.world_tab_id);
        }

    }

}